import React from 'react';
import PropTypes from 'prop-types';

import SpinnerContainer from '../../../../component-library/spinner-container';
import Icon from '../../../../component-library/icon';
import Tile from '../../../../component-library/tile';
import Button from '../../../../component-library/button';

const TryItKey = ({
	apiKey,
	expired,
	getNewApiKey,
	loading,
	allowMock,
}) => (
	<div className="margin-bottom-16">
		<Tile>
			<h3>Try it Out</h3>
			{loading ? (
				<SpinnerContainer
					padding={false}
				/>
			) : (
				<>
					{!apiKey && (
						<>
							<p>
								{allowMock ? (
									<>
										You will need an API key for the Try function to return real data,
										without it the Try function returns mocked data.
									</>
								) : (
									<>You will need an API key to enable the Try function.</>
								)}
							</p>
							<div className="text-right">
								<Button
									type="success"
									label="Get API Key"
									onClick={() => getNewApiKey()}
								/>
							</div>
						</>
					)}
					{(apiKey && !expired) && (
						<>
							<p>Your API key is shown below:</p>
							<div
								className="can-copy-text"
								onClick={() => {
									navigator.clipboard.writeText(apiKey);
								}}
								role="presentation"
							>
								<strong>{apiKey}</strong>
								<Icon icon="copy" title="Click to Copy" />
							</div>
						</>
					)}
					{(apiKey && expired) && (
						<>
							<p>
								Your API key has expired, please apply for a
								new key if you wish to use the Try function:
							</p>
							<div
								className="can-copy-text grey-text margin-bottom-16"
							>
								{apiKey}
								{' '}
								(Expired)
							</div>
							<div className="text-right">
								<Button
									type="success"
									label="Get New API Key"
									onClick={() => getNewApiKey()}
								/>
							</div>
						</>
					)}
				</>
			)}
		</Tile>
	</div>
);

export default TryItKey;

TryItKey.propTypes = {
	apiKey: PropTypes.string.isRequired,
	expired: PropTypes.bool.isRequired,
	getNewApiKey: PropTypes.func.isRequired,
	loading: PropTypes.bool.isRequired,
	allowMock: PropTypes.bool.isRequired,
};
